var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1051_8143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "white",
    fillOpacity: 0.9
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1051_8143)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 69,
    height: 65,
    fill: "url(#pattern0_1051_8143)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1051_8143",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1051_8143",
    transform: "matrix(0.0214097 0 0 0.0227273 -0.00312912 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1051_8143",
    width: 47,
    height: 44,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkta);
export default __webpack_public_path__ + "static/media/Okta.eeba7a9567c5666a15672d8552c846ea.svg";
export { ForwardRef as ReactComponent };